import React, { useContext } from "react";
import { Card, CardContent, Grid, useTheme } from "@mui/material";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { MenuCardProps } from "./MenuCardProps";
import { GlobalContext } from "../Utils/Contexts";

export default function MenuCard(props: MenuCardProps): JSX.Element {
    const cellWidths = {
        xs: 12,
        sm: 6,
        md: 4,
        lg: 3,
        xl: 2,
    };

    const context = useContext(GlobalContext);
    const theme = useTheme();

    const backgroundColor = props.isReadOnly ? theme.cardStatus.readonly : props.isOpened ? theme.cardStatus.opened : theme.cardStatus.unopened;
    const textColor = props.isReadOnly ? "#aaaaaa" : "primary.light";

    return (
        <Grid item xs={cellWidths.xs} sm={cellWidths.sm} md={cellWidths.md} lg={cellWidths.lg} xl={cellWidths.xl}>
            {/*<Card sx={{ height: 140 }} onClick={() => props.openCard(props.title)}>*/}
            <Card sx={{ height: 140, backgroundColor: { backgroundColor } }} onClick={() => props.openCard(props.title)}>
                <CardContent>
                    <Typography color={textColor} fontWeight="bold" textAlign={"center"}>
                        {props.title}
                    </Typography>
                    <Box color={textColor} sx={{ mt: 0.5, height: 65 }} textAlign={"center"}>
                        {props.menuCardContent?.details}
                    </Box>
                    <Box textAlign={"center"}>{props.menuCardContent?.validationMessages}</Box>
                </CardContent>
            </Card>
        </Grid>
    );
}
